// extracted by mini-css-extract-plugin
module.exports = {"tableBlock":"style_tableBlock__6nD3L","tableContainer":"style_tableContainer__vN71z"};